import { render, staticRenderFns } from "./property-invoice.vue?vue&type=template&id=01844c64&scoped=true&"
import script from "./property-invoice.vue?vue&type=script&lang=js&"
export * from "./property-invoice.vue?vue&type=script&lang=js&"
import style0 from "./property-invoice.vue?vue&type=style&index=0&id=01844c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01844c64",
  null
  
)

export default component.exports